import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_COLLECTION_LOAD_BY_ID,
    ACTION_COLLECTION_CREATE,

    ICollectionLoadByIdAction,
    ICollectionLoadFailureAction,
    ICollectionLoadSuccessAction,

    ICollectionCreateAction,
    ICollectionCreateFailureAction,
    ICollectionCreateSuccessAction,

    LoadSuccess,
    LoadFailure,

    CreateSuccess,
    CreateFailure

} from "../actions/collection";
import { collectionsApi } from "../services/collections";


export const
    getCollectionsByIdEpic = (action$): Observable<ICollectionLoadSuccessAction | ICollectionLoadFailureAction> => {
        return action$
            .ofType(ACTION_COLLECTION_LOAD_BY_ID)
            .mergeMap((action: ICollectionLoadByIdAction) => {
                return collectionsApi
                    .getCollectionById(action.id)
                    .map(response =>
                        LoadSuccess(response.collection, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    createCollectionEpic = (action$): Observable<ICollectionCreateSuccessAction | ICollectionCreateFailureAction> => {
        return action$
            .ofType(ACTION_COLLECTION_CREATE)
            .mergeMap((_action: ICollectionCreateAction) => {
                return collectionsApi
                    .createCollection()
                    .map(response =>
                        CreateSuccess(response.collection, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



